<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/userCenter' }">用户中心</el-breadcrumb-item>
					</el-breadcrumb>

					<el-row class="user-info">
						<el-col :span="24" class="user mar_bottom" style="border-bottom: 1px solid #C0C4CC;">
							<el-row class="detail_info mar_bottom">
								<el-col :span="4" class="detail_info_image">
									<el-avatar :size="60"><img :src="store.state.userInfo.headimgurl ? store.state.userInfo.headimgurl : require('../../static/headImage.jpg')" /></el-avatar>
								</el-col>
								<el-col :span="20" class="detail_info_mark">
									<el-row class="name mar_bottom10">
										<el-col :span="24">{{ store.state.userInfo.name ?store.state.userInfo.name:''}}</el-col>
									</el-row>
									<el-row class="name mar_bottom10">
										<el-col :span="24">{{ store.state.userInfo.telephone ? store.state.userInfo.telephone:'' }}</el-col>
									</el-row>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="24">
							<el-menu :default-active="activeIndex" active-text-color="#409EFF" class="el-menu-demo" mode="horizontal" @select="handleSelect">
								<el-menu-item index="1">我的收藏</el-menu-item>
								<el-menu-item index="2">我的积分</el-menu-item>
								<el-menu-item index="3">我的订单</el-menu-item>
								<el-menu-item index="4">客户管理</el-menu-item>
								<el-menu-item index="5">我的客服</el-menu-item>
								<el-menu-item index="6">我的反馈</el-menu-item>
								<el-menu-item index="7">联系我们</el-menu-item>
							</el-menu>
						</el-col>
					</el-row>

					<el-row v-if="activeIndex == 1" class="page save">
						<el-col  :xs="5" :sm="5" :md="5" :lg="4" :xl="4" class="type">
							<el-radio-group v-model="tableName" @change="getMyColl">
								<el-radio border v-for="(item, index) in dictList" :key="index" :label="item.value">{{ item.label }}</el-radio>
							</el-radio-group>
						</el-col>
						<!-- 收藏的载体平台 -->
						<template v-if="tableName == 'msg_platform'">
							<el-col  :xs="19" :sm="19" :md="19" :lg="20" :xl="20"  class="table">
								<div class="lists">
									<template v-if="collList.length > 0">
										<div class="list" v-for="(item, index) in collList" :key="index">
											<div class="list_content">
												<el-image class="img" :src="item.image ? imgPath(item.image) : require('../../static/p.jpg')" fit="contain"></el-image>
												<div class="info">
													<div class="name">{{ item.name }}</div>
													<div class="address">地址：{{ item.address }}{{ item.address }}</div>
													<div class="tags">
														<template v-if="item.keywords&&item.keywords!= ''">
														<el-tag v-for="tag in (item.keywords || '').split(',')" :key="tag" class="tag" type="info" effect="plain" size="small">
															{{ tag }}
														</el-tag>
														</template>
													</div>
												</div>
											</div>
										</div>
									</template>
									<template v-else>
										<div style="text-align: center;width: 100%;">{{ more }}</div>
									</template>
								</div>
							</el-col>
						</template>
						<!-- 高技术人才
						<template v-else-if="tableName == 'msg_hight_talents'">
							<el-col  :xs="19" :sm="19" :md="19" :lg="20" :xl="20"  class="table">
								<div class="lists">
									<template v-if="collList.length > 0">
										<div class="list" v-for="(item, index) in collList" :key="index" @click="goDetail(item)">
											<el-image class="img" :src="item.image ? imgPath(item.image) : require('../../static/p.jpg')" fit="contain"></el-image>
											<div class="info">
												<div class="user">
													<div class="name">{{ item.name }}</div>
													<div class="edu">{{ item.education }}</div>
												</div>
												<div class="addr">工作单位：{{ item.company }}</div>
											</div>
											<div class="buttons">
												<div class="call">
													<i class="el-icon-chat-dot-round"></i>
													联系我
												</div>
											</div>
										</div>
									</template>
									<template v-else>
										<div style="text-align: center;width: 100%;">{{ more }}</div>
									</template>
								</div>
							</el-col>
						</template> -->
						<!-- 收藏的服务产品 -->
						<template v-else-if="tableName == 'msg_product'">
							<el-col  :xs="19" :sm="19" :md="19" :lg="20" :xl="20"  class="table">
								<div class="lists">
									<template v-if="collList.length > 0">
										<div class="list" v-for="(item, index) in collList" :key="index">
											<div @click="goDetail(item)">
												<el-image class="img" :src="item.image ? imgPath(item.image) : require('../../static/p.jpg')" fit="contain"></el-image>
												<div class="info">
													<div class="name">{{ item.name }}</div>
													<div class="price">￥{{ item.price }}</div>
												</div>
											</div>
											<div class="buttons">
												<div class="buy" @click="toWechatPay(item.id, item.price)">
													<i class="el-icon-shopping-cart-full"></i>
													订购
												</div>
												<div class="call" @click="call('咨询热线',item.telephone)">
													<i class="el-icon-chat-dot-round"></i>
													联系我
												</div>
											</div>
										</div>
									</template>
									<template v-else>
										<div style="text-align: center;width: 100%;">{{ more }}</div>
									</template>
								</div>
							</el-col>
						</template>
						<!-- 金融创投 -->
						<template v-else-if="tableName == 'msg_carrier'">
							<el-col  :xs="19" :sm="19" :md="19" :lg="20" :xl="20"  class="table1">
								<div class="lists">
									<template v-if="collList.length > 0">
										<div class="list" v-for="(item, index) in collList" :key="index">
											<div class="list_content" @click="goDetail(item)">
												<el-image class="img" :src="item.image ? imgPath(item.image) : require('../../static/p.jpg')" fit="contain"></el-image>
												<div class="info">
													<div class="name">{{ item.name }}</div>
													<div class="address">地址：{{ item.address }}{{ item.address }}</div>
													<div class="tags">
														<template v-if="item.keyword&&item.keyword== ''">
															<el-tag v-for="tag in (item.keyword || '').split(',')" :key="tag" class="tag" type="info" effect="plain" size="small">
																{{ tag }}
															</el-tag>
														</template>
													</div>
												</div>
											</div>
										</div>
									</template>
									<template v-else>
										<div style="text-align: center;width: 100%;">{{ more }}</div>
									</template>
								</div>
							</el-col>
						</template>
					</el-row>
					<div v-else-if="activeIndex == 3" class="page table order">
						<div class="lists">
							<template v-if="orderList.length > 0">
								<div class="list" v-for="(item, index) in orderList" :key="index">
									<div @click="goDetail(item)">
										<el-image class="img" :src="item.product.image ? imgPath(item.product.image) : require('../../static/p.jpg')" fit="contain"></el-image>
										<div class="info">
											<div class="name">{{ item.product.name }}</div>
											<span class="price">￥{{ item.product.price }}</span>
											<span class="name">x{{ item.counts }}</span>
											<div class="time">下单时间：{{ item.createDate }}</div>
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div style="margin: 0 auto;">暂无数据</div>
							</template>
						</div>
					</div>
					<el-row v-else-if="activeIndex == 6" class="page guest">
						<el-col :span="24" v-if="guest_flag" class="table">
							<el-button type="primary" @click="changeGuest()">我要反馈</el-button>
							<div class="lists">
								<div class="list" v-for="(item, index) in guestBookList" :key="index" @click="goDetail(item)">
									<el-row>
										<el-col :span="20" class="ask mar_bottom10">{{ item.content }}</el-col>
										<el-col :span="4" style="text-align: right;color: rgba(153, 153, 153, 1);">{{ item.createDate }}</el-col>
									</el-row>
									<el-row>
										<el-col :span="20" class="answer mar_bottom10">回复：{{ item.re_contet }}</el-col>
										<el-col :span="4" style="text-align: right;color: rgba(153, 153, 153, 1);"></el-col>
									</el-row>
								</div>
							</div>
						</el-col>

						<el-col :span="12" v-else>
							<el-form :model="form" label-width="100px">
								<el-form-item label="问题与意见"><el-input type="textarea" v-model="form.content"></el-input></el-form-item>
								<el-form-item label="上传图片">
									<el-upload
										action="https://xyqyfw.com/msgplt/api/file/uploadImage"
										list-type="picture-card"
										:file-list="form.fileUrl"
										:on-change="handleChange"
									>
										<i class="el-icon-plus"></i>
									</el-upload>
								</el-form-item>
								<el-form-item label="姓名"><el-input v-model="form.name"></el-input></el-form-item>
								<el-form-item label="联系方式"><el-input v-model="form.phone"></el-input></el-form-item>
								<el-form-item>
									<el-button type="primary" @click="guestSubmit()">立即创建</el-button>
									<el-button @click="guest_flag = true">取消</el-button>
								</el-form-item>
							</el-form>
						</el-col>
					</el-row>
				</div>
			</el-main>
			<el-dialog title="扫码支付" :visible.sync="dialogVisible" width="30%" >
				<span style="text-align: center;display: block;"><img style="width: 340px;height: 340px;" :src="QRcode" /></span>
				<span style="text-align: center;display: block;margin-top: 10px;">扫码支付{{ money }}元</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button @click="toOrder()">已支付</el-button>
				</span>
			</el-dialog>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import { dictList, getMyColl, orderlist, myGuestBookList, saveGuestBook, buyProduct } from '@/api';
import store from '@/store/index.js';
export default {
	name: 'userCenter',
	components: {
		sHeader,
		sFooter,
		sCopyRight
	},
	data() {
		return {
			store:store,
			activeIndex: '1', //tab切换
			tableName: '', //我的收藏左侧类型
			dictList: [], //我的收藏左侧类型
			guest_flag: true, //我的反馈列表与表单切换

			collList: [], //我的收藏列表

			orderList: [], //我的订单

			form: {	
				content: '',
				fileUrl: [],
				phone: '',
				name: ''
			},
			token: '',
			more: '加载中...',
			guestBookList: [], //我的反馈
			QRcode: '',
			orderId: '',
			money: 0,
			dialogVisible: false
		};
	},
	mounted() {
		this.token = localStorage.getItem('token');
		this.getDictList();
	},
	methods: {
		//机构详情
		goCompanyDetail(item){
			let routeUrl = this.$router.resolve({
				path:'/institutionDetail',   //跳转的路径
				query:{           //路由传参时push和query搭配使用 ，作用时传递参数
					id:item.id , 
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		toWechatPay(id, money) {
			buyProduct({
				cnts: 1,
				type: 'PC',
				productID: id
			}).then(res => {
				this.QRcode = this.$imgBaseUrl + res.data.imgUrl;
				this.orderId = res.data.orderNo;
				this.dialogVisible = true;
				this.money = money;
			});
		},
		//
		toOrder() {
			this.$router.push({
				path: '/orderDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: this.orderId
				}
			});
			
		},
		//获取字典列表
		getDictList() {
			let _this = this;
			dictList({
				type: 'msg_table_name'
			}).then(res => {
				if(res.data.length > 0){
					res.data.forEach(function(item){
						if( item.value == 'msg_platform'|| item.value == 'msg_product'|| item.value == 'msg_carrier'){//载体平台 服务产品 金融创投
						    _this.dictList.push(item);
						}
					})
					if(_this.dictList.length>0){
						_this.tableName = _this.dictList[0].value;
						_this.getMyColl();
					}
				}
			});
		},
		//切换菜单
		handleSelect(key) {
			this.activeIndex = key;
			switch (key) {
				case '1': //我的收藏
					this.getMyColl();
					break;
				case '2'://我的积分
					break;
				case '3': //我的订单
					this.getOrderList();
					break;
				case '4': //客户管理
					window.open('https://xyqyfw.com/weixing', '_blank');
				
					break;
				case '5': //我的客服
					this.call('客服热线', '0710-3282168');
					break;
				case '6': //我的反馈
					this.getMyGuestBookListList();
					break;
				default: //联系我们
					this.call('联系方式', '0710-3282168');
					break;
			}
		},
		getMyColl() {
			let _this = this;
			getMyColl({
				tableName: _this.tableName
			}).then(res => {
				console.log('=res=',res)
				if (res.data.list) {
					_this.$nextTick(() => {
						_this.collList = res.data.list;
					});
				}else{
					_this.more = '暂无数据';
					_this.collList = [];
				}
			});
		},
		//获取我的订单列表
		getOrderList() {
			let _this = this;
			orderlist().then(res => {
				if (res.data.list) {
					_this.$nextTick(() => {
						_this.orderList = res.data.list;
					});
				}
			});
		},
		//获取我的反馈列表
		getMyGuestBookListList() {
			let _this = this;
			myGuestBookList().then(res => {
				if (res.data.list) {
					_this.$nextTick(() => {
						_this.guestBookList = res.data.list;
					});
				}
			});
		},
		//我要反馈
		changeGuest() {
			this.guest_flag = false;
			this.form.content = '';
			this.form.fileUrl = [];
			this.form.phone = '';
			this.form.name = '';
		},
		handleChange(file, fileList) {
			this.form.fileUrl = fileList.slice(-1);
		},
		//提交反馈
		guestSubmit() {
			let _this = this;
			let param = {
				content: _this.form.content,
				fileUrl: _this.form.fileUrl.length >0 ? _this.form.fileUrl[0].response.url:'',
				phone: _this.form.phone,
				name: _this.form.name
			};
			saveGuestBook(param).then(res => {
				if (res.code == 0) {
					_this.guest_flag = true;
					_this.getMyGuestBookListList();
				}
			});
		},
		//打电话弹框
		call(title, phone) {
			this.$alert(phone ? phone : '暂未提供', title, {
				confirmButtonText: '确定',
				callback: action => {}
			});
		},
		//图片地址
		imgPath(oldPath) {
			return this.$imgBaseUrl + oldPath;
		}
	}
};
</script>

<style lang="scss" scoped>
.page {
	min-height: 524px; /*若没有tabs56  height524 若有height468 */
}

.detail_info_image {
	text-align: center;
}
.detail_info_mark {
	// height: 160px;
}
.name {
	font-size: 14px;
	padding-top: 10px;
	font-weight: 600;
}

.el-menu.el-menu--horizontal {
	border-bottom: none;
}
/*我的收藏*/
.save {
	.type .el-radio-group {
		display: flex;
		flex-direction: column;
	}
	.type .el-radio {
		margin-left: 0 !important;
		margin-right: 0 !important;
		margin-bottom: 10px;
	}
	.table {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
	}
	.lists {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	.img {
		height: 180px;
		padding: 10px;
		width: 100%;
	}
	.list {
		border: 1px solid #cccccc;
		width: 250px;
		margin-left: 15px;
		margin-right: 15px;
		margin-bottom: 30px;
		position: relative;
		border: none;
	}
	.info {
		margin-left: 10px;
		margin-right: 10px;
	}
	.buttons {
		display: flex;
		flex-direction: row;
	}
	.buy,
	.call {
		height: 48px;
		width: 50%;
		background-color: #f5f5f5;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 600;
		cursor: pointer;
	}
	.buy {
		border-right: 1px solid #dddddd;
	}
	.name {
		font-size: 14px;
		padding-top: 10px;
	}
	.tags {
		height: 52px;
		overflow: hidden;
		.tag {
			margin-bottom: 2px;
		}
	}
	.address {
		line-height: 25px;
		height: 50px;
		color: rgba(153, 153, 153, 100);
		font-size: 14px;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		width: 100%;
	}
	.tags {
		height: 52px;
		overflow: hidden;
		.tag {
			margin-bottom: 2px;
		}
	}
	.label {
		/* width: 98px; */
		height: 20px;
		color: rgba(153, 153, 153, 1);
		font-size: 14px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.label span {
		margin-right: 20px;
	}
}
.table1{
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 10px 20px;
	.lists{
		width: 100%;
	}
	.item{
		width: 100%;
		margin-bottom: 20px;
	}
	.list{	
		height: 100%;
		border-bottom:none;
		margin-left: 20px;
		margin-right: 20px;
		cursor: pointer;
	}
	.itemImage,.itemList{
		height: 120px;
	}
	
	.name{	
		font-size: 16px;
	}
	.label{	
		/* width: 98px; */
		height: 20px;
		color: rgba(153, 153, 153, 1);
		font-size: 14px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.label span{
		margin-right: 20px;
	}
}
/*我的订单*/
.order {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 20px;

	.lists {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	.list {
		/* height: 320px; */
		width: 250px;
		border: 1px solid #cccccc;
		margin-left: 15px;
		margin-right: 15px;
		margin-bottom: 30px;
		position: relative;
	}

	.img {
		height: 180px;
		padding: 10px;
		width: 100%;
	}

	.info {
		margin-left: 10px;
		margin-right: 10px;
	}

	.name {
		// height: 26px;
		line-height: 26px;
	}
	.price {
		line-height: 30px;
		height: 30px;
		color: #ee3438;
	}
	.time {
		line-height: 26px;
		color: rgba(153, 153, 153, 1);
	}
}
/*反馈*/
.guest {
	.table {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
	}
	.lists {
		width: 100%;
	}
	.list {
		border-bottom: 1px solid #c0c4cc;
		margin-top: 10px;
		margin-bottom: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/user-center.vue